import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ChannelDashboardPage" */
	'pages/notification/Channel/ChannelDashboardPage'));

export default [{ component, exact: true, path: '/stonecode_notification_channels/:channelId' }];
